// Industry configuration — adding a new industry = adding one entry here.

export const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "retail", label: "Retail" },
  { key: "food", label: "Food & Hospitality" },
  { key: "healthcare", label: "Healthcare" },
  { key: "professional", label: "Professional Services" },
  { key: "auto-home", label: "Auto & Home" },
  { key: "education", label: "Education" },
  { key: "beauty", label: "Beauty & Lifestyle" },
];

const IMG = {
  tyre: "https://images.unsplash.com/photo-1578844251758-2f71da64c96f?crop=entropy&cs=srgb&fm=jpg&q=85",
  restaurant: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkxMzE1NTU3fDA&ixlib=rb-4.1.0&q=85",
  dental: "https://images.unsplash.com/photo-1704455306251-b4634215d98f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxkZW50YWwlMjBjbGluaWMlMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTEzMTU1NjV8MA&ixlib=rb-4.1.0&q=85",
  salon: "https://images.unsplash.com/photo-1600948836101-f9ffda59d250?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxzYWxvbiUyMGhhaXIlMjBiZWF1dHklMjBpbnRlcmlvcnxlbnwwfHx8fDE3OTEzMTU1Njl8MA&ixlib=rb-4.1.0&q=85",
  interior: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxpbnRlcmlvciUyMGRlc2lnbmVyJTIwcm9vbSUyMG1vZGVybnxlbnwwfHx8fDE3OTEzMTU1NzN8MA&ixlib=rb-4.1.0&q=85",
  car: "https://images.unsplash.com/photo-1777175013302-eaf4b3ef785a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjYXIlMjBkZWFsZXJzaGlwJTIwc2hvd3Jvb218ZW58MHx8fHwxNzkxMzE1NTc3fDA&ixlib=rb-4.1.0&q=85",
  realestate: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxyZWFsJTIwZXN0YXRlJTIwbW9kZXJuJTIwaG91c2V8ZW58MHx8fHwxNzkxMzE1NTgzfDA&ixlib=rb-4.1.0&q=85",
  tuition: "https://images.unsplash.com/photo-1758270704787-615782711641?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxzdHVkZW50JTIwc3R1ZHlpbmclMjBjbGFzc3Jvb218ZW58MHx8fDE3OTEzMTU1ODl8MA&ixlib=rb-4.1.0&q=85",
  jewellery: "https://images.unsplash.com/photo-1780277519438-a265738f7878?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxqZXdlbGxlcnklMjBzdG9yZSUyMGVsZWdhbnR8ZW58MHx8fHwxNzkxMzE1NTkzfDA&ixlib=rb-4.1.0&q=85",
};

// crop helpers so one curated photo yields distinct gallery crops
const crop = (url, w, h) => `${url}&w=${w}&h=${h}&fit=crop`;

export const DEMOS = {
  "tyre-auto-care": {
    business: "Prime Auto Tyres",
    industry: "Tyre & Auto Care",
    headline: "Quality Tyres. Expert Care. Safer Journeys.",
    subline: "Tyres, alignment, balancing and complete auto care — all under one roof.",
    accent: "#37474F",
    image: IMG.tyre,
    primaryCta: "WhatsApp for Tyre Enquiry",
    secondaryCtas: ["Get Directions", "Call Now"],
    whatsappMessage:
      "Hi Anjum, I run a tyre & auto care business and I liked the Prime Auto Tyres demo. I want a website like this for my business.",
    nav: ["Tyres", "Services", "Offers", "About", "Contact"],
    servicesTitle: "Tyres & Services",
    services: [
      { title: "Passenger Car Tyres", desc: "Top brands for every budget and driving style." },
      { title: "SUV Tyres", desc: "Tough, comfortable tyres for SUVs and crossovers." },
      { title: "Commercial Vehicle Tyres", desc: "Heavy-duty tyres for load and long routes." },
      { title: "Wheel Alignment", desc: "Computerised alignment for even tyre wear." },
      { title: "Wheel Balancing", desc: "Smooth, vibration-free driving." },
      { title: "Puncture Repair", desc: "Quick, reliable tubeless puncture repair." },
      { title: "Battery", desc: "Car batteries with on-the-spot replacement." },
      { title: "Auto Care", desc: "Nitrogen filling, rotation and safety checks." },
    ],
    offers: ["Seasonal tyre offers", "Alignment + balancing combos", "Fleet & commercial pricing"],
    contactNote: "On your website, these buttons connect directly to your own phone and WhatsApp.",
  },
  restaurant: {
    business: "Madurai Spice Kitchen",
    industry: "Restaurant & Café",
    headline: "Authentic South Indian Flavours, Made Fresh.",
    subline: "Traditional recipes, fresh ingredients and a table waiting for you.",
    accent: "#8D3B2D",
    image: IMG.restaurant,
    primaryCta: "Order on WhatsApp",
    secondaryCtas: ["View Menu", "Get Directions"],
    whatsappMessage:
      "Hi Anjum, I run a restaurant and I liked the Madurai Spice Kitchen demo. I want a website like this for my restaurant.",
    nav: ["Menu", "Specialities", "Gallery", "Reviews", "Contact"],
    servicesTitle: "Our Menu Highlights",
    services: [
      { title: "Meals & Thalis", desc: "Full South Indian meals served the traditional way." },
      { title: "Dosa & Tiffin", desc: "Crispy dosas, idlis and evening tiffin favourites." },
      { title: "Chettinad Specials", desc: "Bold, spicy Chettinad curries and fries." },
      { title: "Biryani", desc: "Aromatic dum biryani made fresh every day." },
      { title: "Filter Coffee", desc: "Strong, frothy degree coffee." },
      { title: "Family Combos", desc: "Value combos for family dining." },
    ],
    contactNote: "On your website, customers can browse your menu and order on WhatsApp directly.",
  },
  "dental-clinic": {
    business: "SmileCare Dental Clinic",
    industry: "Dental Clinic",
    headline: "Confident Smiles Start Here.",
    subline: "Gentle, modern dental care for the whole family.",
    accent: "#2E6E6A",
    image: IMG.dental,
    primaryCta: "Book an Appointment",
    secondaryCtas: ["WhatsApp Clinic"],
    whatsappMessage:
      "Hi Anjum, I run a dental clinic and I liked the SmileCare demo. I want a website like this for my clinic.",
    nav: ["Treatments", "Doctors", "Reviews", "FAQ", "Appointment"],
    servicesTitle: "Treatments",
    services: [
      { title: "General Dentistry", desc: "Check-ups, fillings and preventive care." },
      { title: "Root Canal Treatment", desc: "Painless single-visit root canals." },
      { title: "Teeth Whitening", desc: "Safe, professional whitening." },
      { title: "Braces & Aligners", desc: "Orthodontic options for every age." },
      { title: "Dental Implants", desc: "Permanent replacements for missing teeth." },
      { title: "Kids Dentistry", desc: "Friendly care for little smiles." },
    ],
    contactNote: "On your website, patients can book appointments and reach your clinic on WhatsApp.",
  },
  salon: {
    business: "Glow Studio",
    industry: "Salon & Beauty",
    headline: "Look Good. Feel Confident.",
    subline: "Hair, skin and bridal services by experienced stylists.",
    accent: "#8A4B62",
    image: IMG.salon,
    primaryCta: "Book Appointment",
    secondaryCtas: ["View Packages"],
    whatsappMessage:
      "Hi Anjum, I run a salon and I liked the Glow Studio demo. I want a website like this for my salon.",
    nav: ["Services", "Hair", "Skin", "Bridal", "Packages", "Contact"],
    servicesTitle: "Services & Packages",
    services: [
      { title: "Haircuts & Styling", desc: "Cuts, styling and blow-dry for men and women." },
      { title: "Hair Colour & Spa", desc: "Global colour, highlights and hair spa rituals." },
      { title: "Facials & Cleanups", desc: "Skin care for every skin type." },
      { title: "Bridal Packages", desc: "Complete bridal hair and makeup." },
      { title: "Grooming Combos", desc: "Value combos for regular grooming." },
      { title: "Manicure & Pedicure", desc: "Relaxing hand and foot care." },
    ],
    contactNote: "On your website, clients can view packages and book appointments instantly.",
  },
  "interior-designer": {
    business: "CasaCraft Interiors",
    industry: "Interior Designer",
    headline: "Spaces Designed Around You.",
    subline: "Residential and commercial interiors, from concept to completion.",
    accent: "#6B5B45",
    image: IMG.interior,
    primaryCta: "Discuss Your Project",
    secondaryCtas: ["View Projects"],
    whatsappMessage:
      "Hi Anjum, I am an interior designer and I liked the CasaCraft Interiors demo. I want a website like this to showcase my work.",
    nav: ["Projects", "Residential", "Commercial", "Process", "Contact"],
    servicesTitle: "What We Design",
    services: [
      { title: "Residential Interiors", desc: "Full-home interiors tailored to your lifestyle." },
      { title: "Commercial Spaces", desc: "Offices, showrooms and retail spaces." },
      { title: "Modular Kitchens", desc: "Smart kitchens built for Indian cooking." },
      { title: "Living Spaces", desc: "Living rooms, bedrooms and wardrobes." },
      { title: "Space Planning", desc: "Layouts that make every square foot count." },
      { title: "Turnkey Execution", desc: "Design, material and execution — one team." },
    ],
    contactNote: "On your website, your portfolio builds trust before the first meeting.",
  },
  "car-dealer": {
    business: "Southside Motors",
    industry: "Car Dealer",
    headline: "Quality Cars. Trusted Deals.",
    subline: "Verified used cars and new arrivals with easy financing.",
    accent: "#31435C",
    image: IMG.car,
    primaryCta: "WhatsApp Dealer",
    secondaryCtas: ["View Cars", "Get Directions"],
    whatsappMessage:
      "Hi Anjum, I run a car dealership and I liked the Southside Motors demo. I want a website like this for my showroom.",
    nav: ["Cars", "New Arrivals", "Used Cars", "Financing", "Contact"],
    servicesTitle: "Browse Our Cars",
    services: [
      { title: "New Arrivals", desc: "Fresh stock added every week." },
      { title: "Certified Used Cars", desc: "Inspected, verified and ready to drive." },
      { title: "SUVs & MUVs", desc: "Family favourites in every budget." },
      { title: "Hatchbacks & Sedans", desc: "City-friendly cars at fair prices." },
      { title: "Financing Assistance", desc: "Loan support with leading financiers." },
      { title: "Exchange Offers", desc: "Fair value for your old car." },
    ],
    contactNote: "On your website, every car listing gets its own WhatsApp enquiry button.",
  },
  "real-estate": {
    business: "PrimeSpace Developers",
    industry: "Builder & Contractor",
    headline: "Better Spaces. Better Living.",
    subline: "Thoughtfully designed homes and commercial spaces.",
    accent: "#3F5D45",
    image: IMG.realestate,
    primaryCta: "Request Details",
    secondaryCtas: ["View Projects"],
    whatsappMessage:
      "Hi Anjum, I am a builder and I liked the PrimeSpace Developers demo. I want a website like this for my projects.",
    nav: ["Projects", "Properties", "Amenities", "Gallery", "Enquiry"],
    servicesTitle: "Projects & Properties",
    services: [
      { title: "Ongoing Projects", desc: "Homes under construction with clear timelines." },
      { title: "Ready to Move", desc: "Completed homes ready for your family." },
      { title: "Villas & Plots", desc: "Premium villas and approved plots." },
      { title: "Commercial Spaces", desc: "Shops and office spaces in growing areas." },
      { title: "Amenities", desc: "Landscaping, power backup, security and more." },
      { title: "Site Visits", desc: "Schedule a visit and see the quality yourself." },
    ],
    contactNote: "On your website, every project gets photos, amenities and an enquiry form.",
  },
  tuition: {
    business: "BrightPath Academy",
    industry: "Tuition & Coaching",
    headline: "Helping Students Learn. Helping Them Succeed.",
    subline: "Personal attention, strong fundamentals and proven results.",
    accent: "#41537B",
    image: IMG.tuition,
    primaryCta: "Enquire Now",
    secondaryCtas: ["View Courses"],
    whatsappMessage:
      "Hi Anjum, I run a tuition/coaching centre and I liked the BrightPath Academy demo. I want a website like this for my centre.",
    nav: ["Courses", "Faculty", "Results", "Admissions", "Contact"],
    servicesTitle: "Courses & Classes",
    services: [
      { title: "Classes 6–10", desc: "Maths, Science and English for all boards." },
      { title: "Classes 11–12", desc: "Physics, Chemistry, Maths, Biology, Commerce." },
      { title: "NEET / JEE Foundation", desc: "Early preparation with expert faculty." },
      { title: "Spoken English", desc: "Confidence-building communication classes." },
      { title: "Weekend Batches", desc: "Flexible timings for school students." },
      { title: "Test Series", desc: "Regular tests with personal feedback." },
    ],
    contactNote: "On your website, parents can see courses, results and admissions in one place.",
  },
  jewellery: {
    business: "Sri Lakshmi Jewellers",
    industry: "Jewellery",
    headline: "Tradition Crafted Beautifully.",
    subline: "Gold, diamond and bridal collections crafted with care.",
    accent: "#7A5C2E",
    image: IMG.jewellery,
    primaryCta: "Enquire on WhatsApp",
    secondaryCtas: ["View Collections"],
    whatsappMessage:
      "Hi Anjum, I run a jewellery business and I liked the Sri Lakshmi Jewellers demo. I want a website like this for my showroom.",
    nav: ["Collections", "Gold", "Diamond", "Bridal", "Contact"],
    servicesTitle: "Our Collections",
    services: [
      { title: "Gold Jewellery", desc: "Necklaces, bangles, chains and daily-wear gold." },
      { title: "Diamond Collection", desc: "Certified diamonds in elegant settings." },
      { title: "Bridal Sets", desc: "Complete bridal ensembles for the big day." },
      { title: "Antique & Temple", desc: "Heritage designs crafted traditionally." },
      { title: "Custom Designs", desc: "Made-to-order pieces for special occasions." },
      { title: "Old Gold Exchange", desc: "Transparent exchange at fair value." },
    ],
    contactNote: "On your website, collections build desire and WhatsApp brings enquiries.",
  },
};

export const INDUSTRIES = [
  { name: "Tyre & Auto Care", slug: "tyre-auto-care", category: "auto-home", icon: "tyre", blurb: "Tyres, alignment, balancing & auto care", image: IMG.tyre, demo: true },
  { name: "Car Dealer", slug: "car-dealer", category: "auto-home", icon: "car", blurb: "New & used cars with easy enquiries", image: IMG.car, demo: true },
  { name: "Restaurant & Café", slug: "restaurant", category: "food", icon: "restaurant", blurb: "Menu, specials & WhatsApp ordering", image: IMG.restaurant, demo: true },
  { name: "Hotel & Resort", slug: "hotel-resort", category: "food", icon: "hotel", blurb: "Rooms, amenities & booking enquiries", demo: false },
  { name: "Dental Clinic", slug: "dental-clinic", category: "healthcare", icon: "dental", blurb: "Treatments, doctors & appointments", image: IMG.dental, demo: true },
  { name: "Clinic & Healthcare", slug: "clinic-healthcare", category: "healthcare", icon: "clinic", blurb: "Services, timings & patient enquiries", demo: false },
  { name: "Salon & Beauty", slug: "salon", category: "beauty", icon: "salon", blurb: "Services, packages & bookings", image: IMG.salon, demo: true },
  { name: "Gym & Fitness", slug: "gym-fitness", category: "beauty", icon: "gym", blurb: "Memberships, trainers & schedules", demo: false },
  { name: "Interior Designer", slug: "interior-designer", category: "professional", icon: "interior", blurb: "Portfolio, projects & consultations", image: IMG.interior, demo: true },
  { name: "Builder & Contractor", slug: "real-estate", category: "professional", icon: "builder", blurb: "Projects, properties & enquiries", image: IMG.realestate, demo: true },
  { name: "Tuition & Coaching", slug: "tuition", category: "education", icon: "tuition", blurb: "Courses, results & admissions", image: IMG.tuition, demo: true },
  { name: "Lawyer & CA", slug: "lawyer-ca", category: "professional", icon: "lawyer", blurb: "Services, credentials & consultations", demo: false },
  { name: "Jewellery", slug: "jewellery", category: "retail", icon: "jewellery", blurb: "Collections, bridal & enquiries", image: IMG.jewellery, demo: true },
  { name: "Boutique & Fashion", slug: "boutique-fashion", category: "retail", icon: "boutique", blurb: "Collections, offers & orders", demo: false },
  { name: "Photography", slug: "photography", category: "professional", icon: "photography", blurb: "Portfolio, packages & bookings", demo: false },
  { name: "Wedding & Events", slug: "wedding-events", category: "beauty", icon: "wedding", blurb: "Services, gallery & enquiries", demo: false },
  { name: "Furniture Store", slug: "furniture-store", category: "retail", icon: "furniture", blurb: "Catalogue, offers & enquiries", demo: false },
  { name: "Home Services", slug: "home-services", category: "auto-home", icon: "home", blurb: "Services, areas & quick bookings", demo: false },
  { name: "Packers & Movers", slug: "packers-movers", category: "auto-home", icon: "movers", blurb: "Quotes, services & tracking info", demo: false },
  { name: "Pet Care", slug: "pet-care", category: "auto-home", icon: "pet", blurb: "Grooming, boarding & appointments", demo: false },
];

export { crop };
